import React, {useState} from 'react';
import {
  Card,
  LinkContainer,
  LinkSpace
} from 'app/src/elements';
import { Text, Pressable, View } from 'react-native';
import moment from 'moment';
import { Link } from 'app/src/utils/routing';
import {
  getStatusType,
  getStatus,
  NameLabel,
  StatusLabel,
  NameStatusLabel,
  BoldText
} from 'app/src/components/Sales/elements';

const SaleCard = props => {
  const { sale } = props;

  return (
    <Card style={{border: `3px solid ${getStatusType(sale?.status)}`}}>
      <NameStatusLabel>

        <NameLabel>
          <Link to={`/sales/${sale.id}`}>
            <BoldText>
              {sale.name}
            </BoldText>
          </Link>
        </NameLabel>
        <StatusLabel style={{color: getStatusType(sale?.status)}}>
          <BoldText>
            {getStatus(sale?.status)}
          </BoldText>
        </StatusLabel>

      </NameStatusLabel>
      <Text>Sale Date: {moment(sale.saleOn).format('M-DD-YY')}</Text>
      <Text>Number of Assets: {sale.saleAssets.length}</Text>
    </Card>
  )
}

export default SaleCard;
